import type React from 'react'
import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/helpers/utils'

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
	className?: string
	children: React.ReactNode
	fullWidth?: boolean
	fullHeight?: boolean
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
	({ fullWidth = false, fullHeight = true, className, ...rest }, ref) => (
		<div
			className={cn(
				'mx-auto w-full px-8 lg:px-4',
				fullHeight ? 'h-full' : 'h-auto',
				fullWidth ? 'max-w-full' : 'max-w-[1280px]',
				className
			)}
			ref={ref}
			{...rest}
		/>
	)
)

Container.displayName = 'Container'
